export default "__VITE_ASSET__BIdVe9zK__"